<app-stages [stages]="stages" currentStage="Informacje podstawowe"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <div class="row">
      <div class="col-md-4">
        <div class='form-group' *ngIf='"validityYear" as controlName'>
          <label [for]='controlName'>
            Rok obowiązywania *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @for (item of form.yearList; track $index) {
              <option [value]="item">
                {{ item }}
              </option>
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class="col-md-4">
        <div class='form-group' *ngIf='"validityMonth" as controlName'>
          <label [for]='controlName'>
            Miesiąc obowiązywania *
          </label>
          <select
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            @for (item of monthList; track $index) {
              <option [value]='item'>{{ item }}</option>
            }
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p id="submissionPurposeDesc" class="pb-3">
          Cel złożenia deklaracji *:
        </p>
        <div class="form-group" *ngIf='"submissionPurpose" as controlName'>
          @for (item of submissionPurposeOptions; track $index) {
            <div [ngClass]="submissionPurposeOptions.length > 2 ? 'custom-radio' : 'custom-radio custom-inline'">
              <input (change)="form.submissionPurposeChange(item)"
                     aria-labelledby="submissionPurposeDesc"
                     [name]="controlName"
                     [formControlName]='controlName'
                     type="radio"
                     [id]="controlName + $index"
                     [value]="item">
              <label [for]="controlName + $index">
                {{ item }}
              </label>
            </div>
          }
        </div>
      </div>
      <div class='col-md-8'>
        <div class='form-group' *ngIf='"submissionPurposeAdditionalInfo" as controlName'>
          <label [for]='controlName'>
            Zdarzenie powodujące obowiązek złożenia informacji
          </label>
          <input
            [id]='controlName'
            [formControlName]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            placeholder='Wpisz tu zdarzenie powodujące złożenia informacji'
            type='text'>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.previousTaxOfficeNameAndAddress) {
        <div class="col-md-8">
          <div class='form-group' *ngIf='"previousTaxOfficeNameAndAddress" as controlName'>
            <label [for]='controlName'>
              Nazwa i adres siedziby organu podatkowego *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu nazwę i adres siedziby organu podatkowego'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      @if (form.residenceChangeDate) {
        <div class="col-md-4">
          <div class='form-group' *ngIf='"residenceChangeDate" as controlName'>
            <label [for]='controlName'>
              Data zmiany zamieszkania lub siedziby *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
    </div>
    <div class="row">
      <div class="col-12">
        <p id="entityKindDesc" class="pb-3">
          Podmiot zobowiązany do złożenia informacji *:
        </p>
        <div class="form-group" *ngIf='"entityKind" as controlName'>
          @for (item of entityKindOptions; track $index) {
            <div [ngClass]="submissionPurposeOptions.length > 2 ? 'custom-radio' : 'custom-radio custom-inline'">
              <input aria-labelledby="entityKindDesc"
                     [name]="controlName"
                     [formControlName]='controlName'
                     type="radio"
                     [id]="controlName + $index"
                     [value]="item">
              <label [for]="controlName + $index">
                {{ item }}
              </label>
            </div>
          }
        </div>
      </div>
      <app-alert type="info" [closable]="false">
        Małżonkowie ze wspólnotą majątkową są traktowani jako współwłaściciele czyli w takim przypadki należy wybierać
        opcję współwłaściciel.
      </app-alert>
    </div>
    <div class='application-actions'>
      @if (!uiSettings()?.mobileEmbed) {
        <button
          type='button'
          class='btn btn-secondary'
          (click)='onCancel()'>
          <span>
            Wstecz
          </span>
        </button>
      }
      <button
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
